

export default {
  title: 'Components/DDA Cards/DDA Image Cards/Event Card/event card',
  tags: ['autodocs'],
  argTypes: {
    card_header_text: { control: 'text' },
    card_header_icon: { control: 'text' },
    card_header_icon_id: { control: 'text' },

    image_src: { control: 'text' },
    event_month: { control: 'text' },
    event_date: { control: 'text' },

    header_text: { control: 'text' },
    body_text: { control: 'text' },

    chip_list: { control: 'object' },
    avatar_list: { control: 'object' },

    custom_class: { control: 'text' },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
Use the \`dda-event-card\` component with the following props:

\`\`\`html
<dda-event-card
  image_src="..."
  event_month="..."
  event_date="..."
  header_text="..."
  body_text="..."
  data-chip-list='[...chips]'
  data-avatar-list='[...avatars]'
></dda-event-card>
\`\`\`

\`chip_list\` and \`avatar_list\` are passed as JavaScript properties (not HTML attributes), and internally parsed from JSON via \`data-chip-list\` and \`data-avatar-list\`.
        `,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) =>
      key !== 'chip_list' &&
      key !== 'avatar_list' &&
      value !== undefined &&
      typeof value !== 'object'
    )
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  const chipListJSON = JSON.stringify(args.chip_list || []);
  const avatarListJSON = JSON.stringify(args.avatar_list || []);

  return `
    <dda-event-card
      ${attributes}
      data-chip-list='${chipListJSON}'
      data-avatar-list='${avatarListJSON}'
    ></dda-event-card>
  `;
};

export const Default = Template.bind({});
Default.args = {
  card_header_text: 'Event',
  card_header_icon: 'more_horiz',
  card_header_icon_id: 'cartHeaderAction',

  image_src: 'https://lipsum.app/id/12/1800x700',
  event_month: 'Oct',
  event_date: '26',

  header_text: 'Backend Team',
  body_text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',

  chip_list: [
    { chip_text: '11:49' },
    { chip_text: '29.20.2023' },
    { chip_text: 'Wall St.' },
  ],

  avatar_list: [
    {src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg'},
    {src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg'},
    {src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg'},
    {src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg'},
  ],

  custom_class: '',
  component_mode: '',
};
